"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled");

var _carousel = _interopRequireDefault(require("../../carousel"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InterestingBlock = /*#__PURE__*/function (_React$Component) {
  _inherits(InterestingBlock, _React$Component);

  var _super = _createSuper(InterestingBlock);

  function InterestingBlock() {
    var _this;

    _classCallCheck(this, InterestingBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getGAParam", function (action) {
      var temp = action.split('/');
      return temp[temp.length - 1];
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (action) {
      var gaParam = _this.getGAParam(action);

      (0, _helpers.dataLayerPush)({
        event: 'UAevent',
        category: 'add_to_packet',
        action: "clicked button ".concat(gaParam)
      });
      window.open(action);
    });

    return _this;
  }

  _createClass(InterestingBlock, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          list = _this$props.list,
          blocksTitle = _this$props.blocksTitle;
      var breakpoints = [{
        width: 0,
        slidesToShow: 1,
        showDots: true
      }, {
        width: 640,
        slidesToShow: 2,
        showDots: false
      }, {
        width: 1180,
        slidesToShow: 3,
        showDots: false
      }];
      return /*#__PURE__*/_react["default"].createElement(_styled.InterestingListWrapper, null, blocksTitle && /*#__PURE__*/_react["default"].createElement(_styled.InterestingTitle, null, blocksTitle), /*#__PURE__*/_react["default"].createElement(_styled.InterestingListContainer, null, /*#__PURE__*/_react["default"].createElement(_carousel["default"], {
        "data-test": "Interesting-list",
        visibleCardWidth: 1024,
        showArrows: false,
        responsive: breakpoints,
        align: "center"
      }, list.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index
        }, /*#__PURE__*/_react["default"].createElement(_styled.InterestingEl, null, /*#__PURE__*/_react["default"].createElement(_styled.InterestingTop, {
          back: item.background
        }, /*#__PURE__*/_react["default"].createElement(_styled.InterestingT, null, item.title), /*#__PURE__*/_react["default"].createElement(_styled.InterestingDesc, null, item.desc)), /*#__PURE__*/_react["default"].createElement(_styled.InterestingBottom, null, /*#__PURE__*/_react["default"].createElement(_styled.InterestingBut, {
          type: "secondary",
          onClick: function onClick() {
            return _this2.handleClick(item.action);
          }
        }, item.textButton))));
      }))));
    }
  }]);

  return InterestingBlock;
}(_react["default"].Component);

var _default = InterestingBlock;
exports["default"] = _default;